import React from "react";
import Prateek_pic from "../../assets/Prateek_picture_linkedin.jpeg";
import "./Hero.css";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";

// EXAMPLE: BADGE IMAGE IMPORTS
import awsBadge from "../../assets/Badges/Aws_badge.png";
import aws_educate from "../../assets/Badges/AWS_educate_badge.png";
import ckadBadge from "../../assets/Badges/CKAD.png";
// Add more as needed

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-left">
        <img src={Prateek_pic} alt="Your Name" className="hero-image" />
      </div>
      <div className="hero-right">
        <h1 className="hero-title">
          Hi, I’m <span className="highlight">Prateek Rai Srivastav</span>
        </h1>
        <h2 className="hero-subtitle">
          <Typewriter
            words={[
              "Software Developer",
              "Open Source Contributor",
              "Hackathon Enthusiast",
              "Blogger"
            ]}
            loop={0}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h2>
        <p className="hero-description">
          Passionate about Cloud Computing and Kubernetes. I love building systems from scratch, contributing to open source and write blogs to spread the learning in public initiative.
        </p>
        <Link to="/projects" className="hero-btn">
          View My Work
        </Link>
        <a href="https://github.com/users/prateekrai1/projects/1/views/1?layout=board" className="hero-btn">
           My Open source contributions
        </a>
        <div className="badges-section">
          <h3 className="badges-title">My Certifications & Badges</h3>
          <div className="badges-list">
            <img src={awsBadge} alt="AWS Developer Associate" className="badge-img"/>
            <img src={ckadBadge} alt="CKAD" className="badge-img"/>
            <img src={aws_educate} alt="CKA" className="badge-img"/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
